__webpack_public_path__ = window.location.pathname;
//import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'bootstrap/dist/css/bootstrap.css';
import './style/Global.css';
import './routing/init';
import './store/init';
import ReactDOM from 'react-dom';
import React from 'react';
//import { AppContainer } from 'react-hot-loader';
import debug from 'debug';
import AuthenticationController from './controllers/AuthenticationController';
import KeyboardShortcuts from './keyboard-shortcuts/KeyboardShortcuts';
import initVariables from './store/init-legacy';
import Startup from './basic/Startup';
import System from './basic/System';
import Storage from './protocol/Storage';
import { HISTORY_BEGIN_URL, HISTORY_END_URL } from './util/Constants';

if(System.isDesktop()) {
  __webpack_public_path__ = '';
}
const Root = require('./Root').default; // This line needs to be require instead of import because webpack reorders import statements, which conflicts with __webpack_public_path__ above
//import "./style/global.vab.css";

window._debug = debug;

require('./util/handleFiles');
require('./util/handleItems');
require('./util/mapObject');

initVariables();

AuthenticationController.setupOnAuthFailure();

KeyboardShortcuts.addTopLevelKeydownListener();

window.render = () => ReactDOM.render(<Root />, document.getElementById('root'));

// Required for proper resizing of rows on ListAssetView.
window.onresize = () => window.render();

window.onload = () => {
  if(window.history.length===1) {
    Storage.set(HISTORY_BEGIN_URL, window.location.href);
    Storage.set(HISTORY_END_URL,'');
  }
};

// Everything start from requesting the current user
AuthenticationController.issueGetCredentials();

/* if (module.hot) {
  module.hot.accept('./Root.js', () => {
    const NextRootContainer = require('./Root').default;
    window.render(NextRootContainer);
  });
} */
